import { useApplication } from '@/hooks/useApplication';
import { ConfigurationVariable } from '@/types/metadata/metadata';
import { signalUtil } from '@/util/validation/signal';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { FC } from 'react';
import { ParamProps } from './ParamRenderer';

const ParamSignal: FC<ParamProps> = (props) => {
  const configuration = props.configuration as ConfigurationVariable;
  const { application } = useApplication();

  const initialValue = signalUtil().getValue(props.configuration, props.initialValue);

  const signals = application?.signals || [];

  const handleChange = (event: SelectChangeEvent) => {
    props.onChange([props.configuration.value, parseInt(event.target.value, 10)]);
  };

  return (
    <FormControl fullWidth size='small' required={props.configuration.required}>
      <InputLabel id='select-signal-label'>{configuration.label}</InputLabel>
      <Select
        labelId='select-signal-label'
        id='select-signal'
        value={initialValue?.toString() || ''}
        label={configuration.label}
        onChange={handleChange}
        required={props.configuration.required}
        error={!!props.errors?.length}
      >
        {initialValue && <MenuItem key={`signal ${0}`} value={undefined} sx={{ height: 30 }} />}
        {signals
          .sort((signalA, signalB) => signalA.name.localeCompare(signalB.name))
          .map((signal) => (
            <MenuItem key={`signal ${signal.id}`} value={signal.id}>
              {signal.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default ParamSignal;
